var React = require('react');

function LiveEvent (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"3","y":"3","width":"18","height":"14","rx":"1","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("line",{"x1":"6","y1":"21","x2":"18","y2":"21","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","key":1})]);
}

LiveEvent.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = LiveEvent;

LiveEvent.default = LiveEvent;
